module.exports = __webpack_public_path__ + "img/timer-icon.48e13fa2.png";